import { ServiceCardProps, ServiceProps } from "@/types/service/service.type";
import { IconType } from "react-icons";
import { BsFillGrid1X2Fill, BsLightningChargeFill } from "react-icons/bs";
import { FaOpencart, FaRegCreditCard } from "react-icons/fa";
import { FaUserGroup, FaMobileScreen } from "react-icons/fa6";
import {
  FiCode,
  FiLayout,
  FiPenTool,
  FiShoppingCart,
  FiSmartphone,
} from "react-icons/fi";
import { GiArchiveResearch } from "react-icons/gi";
import { GrSystem } from "react-icons/gr";
import { IoAnalytics } from "react-icons/io5";
import { LuAppWindow } from "react-icons/lu";
import { MdLocalShipping, MdOutlineManageSearch } from "react-icons/md";
import { PiFigmaLogoThin } from "react-icons/pi";
import { RxLightningBolt } from "react-icons/rx";
import { SiTmux, SiVorondesign } from "react-icons/si";
import { TbDeviceImacCode, TbDeviceMobile } from "react-icons/tb";

/** Structural service data — text lives in dict.servicesPage.services. */
export const servicesData: ServiceProps[] = [
  {
    id: "1",
    key: "ecommerce",
    isHomePage: true,
    categories: ["Frontend Development", "Backend Development", "Bug Fixes"],
    thumbnail: "/assets/services/thumbnails/ecommerce.avif",
    video: "/assets/videos/ecommerce.webm",
    background: "/assets/services/ecommerce.avif",
    icon: "/assets/service-icons/e-commerce-solutions-icon.svg",
    bannerImage: "/assets/services/banner-services/ecommerce.png",
    subServices: [
      { Icon: FaOpencart },
      { Icon: FaRegCreditCard },
      { Icon: MdLocalShipping },
      { Icon: IoAnalytics },
    ],
  },
  {
    id: "5",
    key: "mobileApp",
    isHomePage: true,
    categories: ["iOS", "Android", "Cross-Platform"],
    thumbnail: "/assets/services/thumbnails/mobile-app.avif",
    video: "/assets/videos/mobile-app.webm",
    background: "/assets/services/mobile-app.avif",
    icon: "/assets/service-icons/mobile-app.svg",
    bannerImage: "/assets/services/banner-services/mobile-app.png",
    subServices: [
      { Icon: TbDeviceMobile },
      { Icon: FaMobileScreen },
      { Icon: BsLightningChargeFill },
      { Icon: GrSystem },
      { Icon: RxLightningBolt },
      { Icon: FaUserGroup },
    ],
  },
  {
    id: "3",
    key: "custom",
    isHomePage: true,
    categories: ["UI Design", "UX Design", "Design Systems"],
    thumbnail: "/assets/services/thumbnails/custom.avif",
    video: "/assets/videos/custom.webm",
    background: "/assets/services/custom.avif",
    icon: "/assets/service-icons/custom-website-deveopment-icon.svg",
    bannerImage: "/assets/services/banner-services/custom-website.png",
    subServices: [
      { Icon: BsFillGrid1X2Fill },
      { Icon: MdOutlineManageSearch },
      { Icon: BsLightningChargeFill },
      { Icon: TbDeviceMobile },
    ],
  },
  {
    id: "2",
    key: "landing",
    isHomePage: true,
    categories: ["User Research", "Wireframing", "Prototyping"],
    thumbnail: "/assets/services/thumbnails/landingpage.avif",
    video: "/assets/videos/landingpage.webm",
    icon: "/assets/service-icons/landing-page-icon.svg",
    background: "/assets/services/landingpage.avif",
    bannerImage: "/assets/services/banner-services/landing-page.png",
    subServices: [
      { Icon: RxLightningBolt },
      { Icon: MdOutlineManageSearch },
      { Icon: PiFigmaLogoThin },
      { Icon: SiTmux },
    ],
  },
  {
    id: "4",
    key: "uiux",
    isHomePage: false,
    categories: ["Mobile UI Design", "Interaction Design", "User Flows"],
    thumbnail: "/assets/services/thumbnails/uiuxdesign.avif",
    video: "/assets/videos/uiuxdesign.webm",
    background: "/assets/services/uiuxdesign.avif",
    icon: "/assets/service-icons/ui-ux-icon.svg",
    bannerImage: "/assets/services/banner-services/uiux-design.png",
    subServices: [
      { Icon: SiVorondesign },
      { Icon: GrSystem },
      { Icon: GiArchiveResearch },
      { Icon: FaUserGroup },
    ],
  },
];

/** Structural-only — name/shortDescription come from dict.navServiceCategoryItems. */
export type ServiceCategoryGroup = "creative" | "development";
export type CreativeServiceKey = "webDesign" | "brandIdentity" | "graphicDesign";
export type DevelopmentServiceKey =
  | "webDevelopment"
  | "mobileAppDevelopment"
  | "ecommerceSolutions";

export const servicesByCategory: {
  creative: { key: CreativeServiceKey; Icon: IconType }[];
  development: { key: DevelopmentServiceKey; Icon: IconType }[];
} = {
  creative: [
    { key: "webDesign", Icon: LuAppWindow },
    { key: "brandIdentity", Icon: SiVorondesign },
    { key: "graphicDesign", Icon: FiPenTool },
  ],
  development: [
    { key: "webDevelopment", Icon: TbDeviceImacCode },
    { key: "mobileAppDevelopment", Icon: FaMobileScreen },
    { key: "ecommerceSolutions", Icon: FaOpencart },
  ],
};


/** Structural-only — text lives in dict.homeServiceCards. Order matches the home banner. */
export const serviceCards: ServiceCardProps[] = [
  {
    number: 1,
    cardKey: "ecommerce",
    Icon: FiShoppingCart,
    image: "/assets/services/homepage-services/ecommerce.avif",
    imageAlt: "Ecommerce website storefront preview",
  },
  {
    number: 2,
    cardKey: "mobileApp",
    Icon: FiSmartphone,
    image: "/assets/services/homepage-services/mobile-app.avif",
    imageAlt: "Mobile app development illustration",
  },
  {
    number: 3,
    cardKey: "custom",
    Icon: FiCode,
    image: "/assets/services/homepage-services/custom-website.avif",
    imageAlt: "Custom website design preview",
  },
  {
    number: 4,
    cardKey: "landing",
    Icon: FiLayout,
    image: "/assets/services/homepage-services/landing-page.avif",
    imageAlt: "Landing page design preview",
  },
  {
    number: 5,
    cardKey: "uiux",
    Icon: FiPenTool,
    image: "/assets/services/homepage-services/uiux-design.avif",
    imageAlt: "UI/UX design preview",
  },
];
